import Table from "./table";
import Tr from "./tr";
import Th from "./th";
import Td from "./td";

export {Table, Tr, Th, Td};
